import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconArrowLeft"><Path fillRule="evenodd" clipRule="evenodd" d="M9.99775 19.5177L2.47998 12L9.99774 4.48218L11.7655 6.24994L7.26551 10.75H20.9977V13.25H7.26552L11.7655 17.7499L9.99775 19.5177Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowLeft;
